import BookAppointment from "../components/BookAppointment";
import ContactUs from "../components/ContactUs";

const ContactUsPage = () => {
    return (
        <>
      <BookAppointment/>
      <ContactUs />
      </>
    );
}

export default ContactUsPage;